<!--Header-->
<div class="TextCenter">
	<h4>Facility CAASS Visitors Settings:</h4>
</div>

<!--Form-->
<div class="fd-Menu TopMargin">
	<label>Default Pass Template:</label>
	<select [disabled]="Saving == true" class="form-control" name="DefaultPassID" [(ngModel)]="DefaultPassID">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstPassTemplate" [ngValue]="o.IDCardTemplateID">
			{{ o.CardName }}
		</option>
	</select>

	<label>Offender Hit Pass Template:</label>
	<select [disabled]="Saving == true" class="form-control" name="OffenderHitPassID" [(ngModel)]="OffenderHitPassID">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstPassTemplate" [ngValue]="o.IDCardTemplateID">
			{{ o.CardName }}
		</option>
	</select>

	<label>Verification Required Pass Template:</label>
	<select [disabled]="Saving == true" class="form-control" name="VerificationPassID" [(ngModel)]="VerificationPassID">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstPassTemplate" [ngValue]="o.IDCardTemplateID">
			{{ o.CardName }}
		</option>
	</select>
</div>

<div class="fd-CenterMenu TopMargin">
	<label style="max-width: 400px">
		If the list of templates is empty, verify that templates have been created in the CAASS Visitor Pass Designer for this facility and/or district.
	</label>
</div>

<!--Next-->
<div class="TextCenter TopMargin">
	<button [disabled]="Saving == true" class="btn btn-success" (click)="onNext()">
		{{ GetFinishText() }}
	</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
